import React from 'react';

const RefundPolicy = () => {
    return (
        <div className="min-h-[80vh] bg-white flex flex-col items-center py-12">
            <div className="w-full max-w-5xl px-4 flex-grow flex flex-col">
                <h1 className="font-heading text-4xl font-bold text-[#2C3333] mb-8 text-center tracking-tight">
                    Refund Policy
                </h1>
                <div className="flex-grow w-full border border-gray-200 rounded-lg shadow-sm overflow-hidden min-h-[70vh]">
                    <object 
                        data="/policies/03_Refund_Return_Shipping_Policy.pdf" 
                        type="application/pdf" 
                        className="w-full h-full min-h-[70vh]"
                    >
                        <p className="p-8 text-center text-gray-500">
                            Your browser does not support PDFs. 
                            <a href="/policies/03_Refund_Return_Shipping_Policy.pdf" className="text-primary hover:underline ml-2" download>
                                Download the PDF
                            </a>.
                        </p>
                    </object>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;
